<template>
  <div class="qa-container container">
    <h1>退換貨政策</h1>
    <section>
      <div class="text-box">
        <div class="black">
          森女部落提供貼心服務<span class="main">【&nbsp;七天鑑賞期退貨免運費&nbsp;&nbsp;】</span>
        </div>
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;七天鑑賞期說明</div>
        <div class="part">
          單筆訂單收到商品隔日起7天內&nbsp;(&nbsp;包含例假日&nbsp;)&nbsp;，可享一次免運費退換貨服務，不限件數。
        </div>
        ※&nbsp;免運費退換貨是指退回的運費，並非訂單免運唷！<br />
        ※&nbsp;<span class="main">易碎物品</span>
        為避免因物流配送途中導致損壞，請務必於收到包裹
        <span class="main">當天</span>
        拆封確認，若有問題立即通知客服！
      </div>
      <div class="text-box">
        <div class="part">
          因系統需等候物流回檔取件資料後自動開啟
          <span class="main"> 【&nbsp;申請退貨&nbsp;】 </span>
          的按鍵，請於收到商品
          <span class="main"> 【&nbsp;隔日中午後&nbsp;】 </span>
          線上申請退貨&nbsp;(&nbsp;申請方式請參看下方說明&nbsp;)，
          完成退貨申請後，系統將自動發送「&nbsp;退貨便代碼&nbsp;」至您的信箱，辦理退貨請填妥退換貨申請單並與退貨商品一同包裝完整附回喔！
        </div>
        ※退貨便代碼可至會員中心 &nbsp;<i class="fas fa-arrow-right"></i>&nbsp; 訂單 &nbsp;<i
          class="fas fa-arrow-right"
        ></i
        >&nbsp;<span class="main">【&nbsp;退貨進度&nbsp;】</span>內查詢。
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;退貨流程</div>
        1.&nbsp;收到商品請立即檢查，若有問題，請收到商品的隔天起
        <span class="main"> &nbsp;7&nbsp;天內 </span>
        &nbsp;(&nbsp;包含例假日&nbsp;)&nbsp;線上申請退貨。<br />
        ※&nbsp;請務必先檢查過再下水使用，避免下水後無法退換貨的情況。
      </div>
      <div class="text-box">
        2.&nbsp;登入會員&nbsp;<i class="fas fa-arrow-right"></i>&nbsp;
        點選【&nbsp;人頭圖像&nbsp;】&nbsp;<i class="fas fa-arrow-right"></i>&nbsp;
        <span class="main"> 【&nbsp;訂單&nbsp;】 </span>
        &nbsp;<i class="fas fa-arrow-right"></i>&nbsp;在欲退貨的訂單點選
        <span class="main"> 【&nbsp;查閱&nbsp;】 </span>
        &nbsp;<i class="fas fa-arrow-right"></i>&nbsp;
        <span class="main"> 【&nbsp;申請退貨&nbsp;】 </span>
        。<br />
        ※&nbsp;請注意:&nbsp;只有在訂單送貨狀態為
        <span class="main">「&nbsp;已取貨&nbsp;」</span>
        ，且在申請退貨期限內顧客才可申請退貨。
      </div>
      <div class="text-box">
        <div class="part">
          3.&nbsp; 勾選欲退貨的品項&nbsp;(&nbsp;若退貨後未達滿額贈活動，贈品請一併勾選&nbsp;)
          &nbsp;<i class="fas fa-arrow-right"></i>&nbsp; 點選【&nbsp;退貨原因&nbsp;】 &nbsp;<i
            class="fas fa-arrow-right"
          ></i
          >&nbsp; 填寫【&nbsp;退貨資料/退款資料&nbsp;】 &nbsp;<i class="fas fa-arrow-right"></i
          >&nbsp; 提交退貨申請。<br />
          ※&nbsp;因系統限制，無法將款項退至會員現金帳戶。
        </div>
        <span class="main">
          ▲&nbsp;原付款方式若為【&nbsp;信用卡&nbsp;/&nbsp;LINE
          Pay&nbsp;】，退款一律辦理【&nbsp;退刷&nbsp;】。<br />
          ▲&nbsp;原付款方式若為【&nbsp;貨到付款&nbsp;/&nbsp;ATM
          轉帳&nbsp;】，退款一律退至【&nbsp;銀行帳戶&nbsp;】。
        </span>
      </div>
      <div class="text-box">
        4.&nbsp;系統收到申請將自動發送【&nbsp;退貨便代碼&nbsp;】至您的信箱
        &nbsp;(&nbsp;如&nbsp;24&nbsp;小時內未收到信件，請與客服聯繫&nbsp;)&nbsp; ，也可於訂單
        <span class="main">【&nbsp;退貨進度&nbsp;】</span>內查詢退貨便代碼。<br />
        <span class="main"> ※&nbsp;如不符合退貨規範，客服會通知您並取消退貨申請。 </span>
      </div>
      <div class="text-box">
        <div class="part">
          5.&nbsp;退貨便代碼期限內，將要退貨的商品包裝起來，並填妥退換貨申請單，
          至任一間台灣本島&nbsp;7-11&nbsp;門市操作「&nbsp;ibon&nbsp;」機台辦理退貨程序，
          並列印「&nbsp;退貨便服務單&nbsp;」，拿至&nbsp;7-11&nbsp;櫃台交給超商店員，
          無需另外付費，保留代收收據做為退貨便成功憑證，就順利完成退貨囉！
        </div>
        <div class="part">
          <span class="main">請注意！</span>夾鏈袋&nbsp;/&nbsp;鞋盒等商品本身包裝請勿外漏，
          請在商品包裝外面再用塑膠袋&nbsp;/&nbsp;紙箱完整包裝，保護您的隱私，更避免內容物遺失&nbsp;/&nbsp;破損時的責任歸屬問題。
        </div>
        ※&nbsp;若超過退貨便代碼期限，訂單尚在鑑賞期內未完成退貨便以致代碼失效，需自行將包裹寄回，如因代碼失效且訂單已超過七日鑑賞期將無法為您辦理退貨！
      </div>
      <div class="text-box">
        6.&nbsp;客服收到您的退貨商品，會盡速為您做後續退貨流程喔！<br />
        ※&nbsp;退貨便退回約需&nbsp;5-7&nbsp;個工作天。
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;退回退貨注意事項</div>
        <div class="part">
          <span class="main">
            ※&nbsp;森女使用【&nbsp;電子發票&nbsp;】，若有索取紙本，如訂單有保留商品發票無需附回，
            【&nbsp;全數退貨&nbsp;】則需附回發票。
          </span>
        </div>
      </div>
      <div class="text-box">
        <div class="part">
          1.&nbsp;同筆訂單不限件數&nbsp;(&nbsp;拆單除外&nbsp;)&nbsp;，<span class="main"
            >僅限一次免運費退換貨服務</span
          >，
        </div>
        <div class="part">
          若同筆訂單中第二次申請
          <span class="main"> 退貨 </span>
          ，則需自行負擔運費將商品寄回，若直接用退貨便寄回，將於退款中扣除運費&nbsp;60&nbsp;元。
        </div>
        若同筆訂單中第二次申請
        <span class="main"> 換貨 </span>
        ，則需自行負擔運費將商品寄回並隨貨附上回郵運費&nbsp;70&nbsp;元，
        <span class="main">換貨一律宅配寄出</span>。
      </div>
      <div class="text-box">
        <div class="part">
          2.&nbsp;退貨需於收到商品隔天起&nbsp;7&nbsp;天內&nbsp;(&nbsp;包含例假日&nbsp;)&nbsp;
          申請，超過&nbsp;7&nbsp;天則無法為您處理囉！
        </div>
        ※&nbsp;請務必先申請退貨，若自行寄回恕無法處理。
      </div>
      <div class="text-box">
        <div class="part">3.&nbsp;退貨便包裝尺寸限制&nbsp;(&nbsp;單位:&nbsp;公分&nbsp;)</div>
        <div class="part">
          材積&nbsp;:&nbsp;≦&nbsp;45&nbsp;x&nbsp;30&nbsp;x&nbsp;30&nbsp;
          (&nbsp;最長邊&nbsp;≦&nbsp;45，其它兩邊則需均&nbsp;≦&nbsp;30內&nbsp;)
        </div>
        重量&nbsp;:&nbsp;小於&nbsp;5&nbsp;KG
      </div>
      <div class="text-box">
        5.&nbsp;
        若退貨後，該筆訂單未達滿額禮之門檻，需請您將滿額禮連同商品一同寄回，如果滿額禮已經拆封或使用無法退回，將會扣除滿額禮之售價。
      </div>
      <div class="text-box">
        6.&nbsp;海外買家若需退貨，請先與客服聯繫，商品需自費寄回，若
        <span class="main"> 運送產生稅金也需由買家負擔並從退款扣除 </span>
        。
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">
          <i class="fas fa-heart"></i
          >&nbsp;換貨&nbsp;–&nbsp;瑕疵&nbsp;/&nbsp;錯誤商品&nbsp;/&nbsp;更換顏色尺寸
        </div>
        <div class="part">
          <span class="main"> ※&nbsp;換貨一律宅配寄出 </span>
        </div>
      </div>
      <div class="text-box">
        <div class="part">
          若收到瑕疵或錯誤商品，森女部落深感抱歉！
          請於收到商品隔天起&nbsp;7&nbsp;天內聯繫我們，瑕疵商品請先拍照瑕疵部位，
          傳送至線上客服【&nbsp;LINE&nbsp;/&nbsp;FB&nbsp;/&nbsp;E-mail&nbsp;】，
          客服收到確認後會回覆您並詢問收件資料，三天內請宅配與您收回商品。
        </div>
        <div class="part">
          同筆訂單僅限一次免運費退換貨服務，若同時有退貨與換貨需求請一併包裝由宅配收回，
          如辦理換貨後仍需辦理退貨請自行負擔運費將商品寄回。
        </div>
        <div class="part">※瑕疪品請您幫我們在瑕疪處貼上透明膠帶，以方便做確認作業。</div>
        <div class="part">
          ※&nbsp;若因瑕疵欲更換商品賣場卻售完無貨可換，而需辦理退貨，退款金額將不影響原訂單免運優惠
          ，但若不更換同款商品而選擇退貨，退貨後未達免運則仍需扣除運費喔！
        </div>
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;無法為您辦理退換貨之情況</div>
        <div class="part">
          ▲&nbsp;超過七天鑑賞期&nbsp;(&nbsp;收到商品的隔日起&nbsp;7&nbsp;天內，包含例假日&nbsp;)。
        </div>
        <div class="part">
          ▲&nbsp;已使用過、已下水、配件不完整、人為造成瑕疪、有香水或個人身體氣味。
        </div>
        <div class="part">
          ▲&nbsp;貼身關乎衛生的商品&nbsp;(&nbsp;如襪類、針式耳環、貼身小可愛、內搭襯褲、泳衣、內衣褲、口罩等&nbsp;)。
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/stylesheets/custom/_variable';

.qa-container {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;

  h1 {
    margin-bottom: 1.5rem;
    text-align: center;
    text-indent: 0.25rem;
    letter-spacing: 0.25em;
    @include font-xl;
  }

  section {
    margin-bottom: 2.5rem;

    h2 {
      margin-bottom: 1rem;
      @include font-lg;
    }

    .text-box {
      color: $gray-600;

      .black {
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: $gray-900;
      }

      .part {
        margin-bottom: 0.5rem;
      }

      .main {
        font-weight: 500;
        color: $color-main;
      }

      &:not(:last-child) {
        margin-bottom: 1rem;
      }

      a {
        color: #337ab7;
      }
    }
  }
}
</style>
